import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { SortDescriptor } from "react-aria-components";

import { getSearchQuery } from "components/SearchInput/helpers";

import { sortGroups } from "./sort";
import { IdpGroupWithMapped } from "../types";

export const useFilteredEntities = (
  entities: IdpGroupWithMapped[],
  sortDescriptor: SortDescriptor
) => {
  const [searchParams] = useSearchParams();
  const searchInput = getSearchQuery(searchParams);

  return useMemo(() => {
    let filteredEntities = [...entities];
    // Apply search filter if exists
    filteredEntities = filteredEntities.filter((entity) =>
      entity.name.toLowerCase().includes(searchInput.toLowerCase())
    );

    // Apply sorting if descriptor exists
    if (sortDescriptor.column) {
      filteredEntities = sortGroups(filteredEntities, sortDescriptor);
    }

    return filteredEntities;
  }, [entities, searchInput, sortDescriptor]);
};
